module.exports = __webpack_public_path__ + "static/images/fields/decimal_field.svg";